export type OnboardingTranslationKey =
  | 'onboarding.result.success.title'
  | 'onboarding.result.success.description'
  | 'onboarding.result.failed.title'
  | 'onboarding.result.failed.description'
  | 'onboarding.result.empty.title'
  | 'onboarding.result.empty.description'
  | 'onboarding.result.empty.start'
  | 'onboarding.result.error.title'
  | 'onboarding.result.error.retry'
  | 'onboarding.result.actions.start_over'
  | 'onboarding.result.actions.back_to_dashboard'
  | 'onboarding.result.details.seller_id'
  | 'onboarding.result.details.status'
  | 'onboarding.result.details.products_total'
  | 'onboarding.result.details.products_created'
  | 'onboarding.result.details.products_failed'
  | 'onboarding.result.links.activation'
  | 'onboarding.result.links.vendor_panel'
  | 'onboarding.result.links.shop'
  | 'onboarding.result.section.details'
  | 'onboarding.result.section.next_steps';

const EN_MESSAGES: Record<OnboardingTranslationKey, string> = {
  'onboarding.result.success.title': 'Shop created successfully',
  'onboarding.result.success.description':
    'The shop has been set up and products are being processed.',
  'onboarding.result.failed.title': 'Shop creation failed',
  'onboarding.result.failed.description':
    'Something went wrong while creating the shop. You can try again or contact support.',
  'onboarding.result.empty.title': 'No onboarding result yet',
  'onboarding.result.empty.description':
    'Start the onboarding flow to see the next steps here.',
  'onboarding.result.empty.start': 'Start onboarding',
  'onboarding.result.error.title': 'Onboarding failed',
  'onboarding.result.error.retry': 'Try again',
  'onboarding.result.actions.start_over': 'Start new onboarding',
  'onboarding.result.actions.back_to_dashboard': 'Back to dashboard',
  'onboarding.result.details.seller_id': 'Seller ID',
  'onboarding.result.details.status': 'Status',
  'onboarding.result.details.products_total': 'Total products',
  'onboarding.result.details.products_created': 'Products created',
  'onboarding.result.details.products_failed': 'Products failed',
  'onboarding.result.links.activation': 'Activate Account',
  'onboarding.result.links.vendor_panel': 'Open Vendor Panel',
  'onboarding.result.links.shop': 'Open Shop',
  'onboarding.result.section.details': 'Details',
  'onboarding.result.section.next_steps': 'Next Steps',
};

export function tOnboarding(key: OnboardingTranslationKey): string {
  return EN_MESSAGES[key] ?? key;
}
